import Vue from 'vue'
import options from 'vue-countup-directive'

Vue.directive('countUp', options)
